import {match} from 'ts-pattern';

import {VehicleRecommendationMatchCriterion} from '@dms/api/finance';
import i18n from '@dms/i18n';

export const getMatchCriterionLabel = (criterion: VehicleRecommendationMatchCriterion) =>
  match(criterion)
    .with('make', () => i18n.t('entity.vehicle.labels.make'))
    .with('modelFamily', () => i18n.t('entity.vehicle.labels.model'))
    .with('trimLevel', () => i18n.t('entity.vehicle.labels.trimLevel'))
    .with('fuelType', () => i18n.t('entity.vehicle.labels.fuelType'))
    .with('transmission', () => i18n.t('entity.vehicle.labels.transmission'))
    .with('drive', () => i18n.t('entity.vehicle.labels.drive'))
    .with('bodyStyle', () => i18n.t('entity.vehicle.labels.body'))
    .with('bodyColor', () => i18n.t('entity.vehicle.labels.bodyColor'))
    .with('condition', () => i18n.t('entity.vehicle.labels.condition'))
    .with('features', () => i18n.t('entity.vehicle.labels.features'))
    .with('year', () => i18n.t('entity.vehicle.labels.year'))
    .with('mileage', () => i18n.t('entity.vehicle.labels.mileage'))
    .with('power', () => i18n.t('entity.vehicle.labels.power'))
    .with('cubicCapacity', () => i18n.t('entity.vehicle.labels.engineCapacity'))
    .with('price', () => i18n.t('general.labels.price'))
    .with('vatDeductible', () => i18n.t('general.labels.vatDeductible'))
    .with('salePresetId', () => i18n.t('entity.vehicle.labels.salePreset'))
    .exhaustive();
